// extracted by mini-css-extract-plugin
export default {"dach_nav_link":"dachlinks_dach_nav_link__za-JA","link_text":"dachlinks_link_text__fdSkN"};